module.exports = __webpack_public_path__ + "static/media/StatIcon.fcaddb28.svg";